<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-table hover small responsive show-empty
                 style="font-size:1em;"
                 :fields="fields"
                 :items="lifecycleMetrics"
                 :busy="isLoading">
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>

          <template v-slot:empty="scope">
            <p>No data found</p>
          </template>
          <template #table-caption></template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
            <strong>Loading, Please Wait...</strong>
          </div>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import {statusOptions} from "@/mixins/statusOptions";

export default {
  components: {},
  mixins: [
    statusOptions
  ],
  props: {partitionType: String},
  data() {
    return {
      isLoading: true,
      lifecycleMetrics: [],
    }
  },
  computed: {
    fields: function () {
      let results = []
      if (this.partitionType === 'Fiscal Year') {
        results.push({key: 'partition', sortable: true, label: 'Fiscal Year'})
      } else {
        results.push({key: 'partition', sortable: true, label: 'Division'})
      }
      for (var idx in this.hiringStatusOptions) {
        results.push({
          key: `averages.${this.hiringStatusOptions[idx].value}`,
          sortable: true,
          label: this.hiringStatusOptions[idx].text
        })
      }
      return results
    }
  },
  created() {
    this.isLoading = true
    this.loadHiringStageSummary();
  },
  watch: {},
  methods: {
    loadHiringStageSummary() {
      if (this.partitionType === 'Fiscal Year') {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/lifecycleMetrics`)
            .then(response => {
              this.lifecycleMetrics = this.processData(response.data)
              console.log("Fiscal Year Lifecycle Metrics")
              console.log(response.data)
              this.isLoading = false
            })
      } else if (this.partitionType === 'Division') {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/divisionLifecycleMetrics`)
            .then(response => {
              this.lifecycleMetrics = this.processData(response.data)
              console.log("By Division Lifecycle Metrics")
              console.log(response.data)
              this.isLoading = false
            })
      }
    },
    processData(data) {
      data.forEach(row => {
            if (row.partition === 'Goal') {
              for (const requestStatusValue in row.averages) {
                if(row.averages[requestStatusValue] === 0)
                  row.averages[requestStatusValue] = ''
              }
            }
            else{
              for (const requestStatusValue in row.averages) {
                row.averages[requestStatusValue] = row.averages[requestStatusValue].toFixed(2)
              }
            }
          }
      )
      return data
    },
  }
}
</script>